/* eslint-disable */

import React from 'react'
import { useTypedSelector } from './redux/hooks'
import { appState } from './redux/slice/AppSlice'
import IndexRouter from './routes/IndexRouter'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './locales/i18n'
import { setupMessageListener } from './notificationService'

const App = () => {
  useEffect(() => {
    const handlePasteAnywhere = (event: any) => {
      navigator?.clipboard?.writeText(window?.getSelection()?.toString()?.trim() || ' ')
    }
    window?.addEventListener('copy', handlePasteAnywhere)
    return () => {
      window?.removeEventListener('copy', handlePasteAnywhere)
    }
  }, [])
  const { theme } = useTypedSelector(appState)

  theme === 'dark'
    ? document.body.classList.add('dark-theme')
    : document.body.classList.remove('dark-theme')

  const { i18n } = useTranslation()

  useEffect(() => {
    // Set the direction attribute on initial load
    document.documentElement.dir = i18n.dir(i18n.resolvedLanguage)
  }, [i18n])

  // handling the notifications
  useEffect(() => {
    // requestNotificationPermission()
    setupMessageListener()
  }, [])

  return (
    <div className="app">
      <IndexRouter />
    </div>
  )
}

export default App
